import {updateActiveWidgetId} from 'common/src/modules/dashboards/store/dashboardPage.slice';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {AccountAnalyticsToolName} from '../accountAnalyticsAgent.enums';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';

const inputSchema = z.object({
  dashboardId: z.number().describe('The ID of the dashboard'),
  widgetId: z.number().describe('The ID of the widget'),
});

function highlightAccountWidgetTool(store: CLStore) {
  async function execute({
    input: {dashboardId, widgetId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const queryParams = {
      ...Object.fromEntries(new URLSearchParams(document.location.search).entries()),
    };

    routingService.redirectTo({
      url: Routes.DashboardInfo,
      pathParams: {
        dashboardId: String(dashboardId),
      },
      queryParams,
    });

    store.dispatch(updateActiveWidgetId(widgetId));

    return toolResult('Success');
  }

  return tool({
    name: AccountAnalyticsToolName.HighlightAccountWidget,
    displayName: 'Preparing widget',
    description: 'highlight a widget',
    execute,
    inputSchema,
  });
}

export default highlightAccountWidgetTool;
